import { ICopyable } from '../core/copyable.interface';
import { IIdentifiable } from '../core/identifiable.interface';
import { IAttachment } from './interface/attachment.interface';

/**
 * Represente un document d'un dossier
 */
export class Attachment implements ICopyable<Attachment>, IIdentifiable {
    _id: any;

    get id(): any {
        return this._id;
    }

    set id(value: any) {
        this._id = value;
    }

    documentId: string;

    name: string;

    size: number;

    creationDate: string;

    isFavorite: boolean;

    public createCopy(): Attachment {
        const instance = new Attachment();
        instance.id = this.id;
        instance.documentId = this.documentId;
        instance.name = this.name;
        instance.size = this.size;
        instance.creationDate = this.creationDate;
        instance.isFavorite = this.isFavorite;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.documentId = other.documentId;
        this.name = other.name;
        this.size = other.size;
        this.creationDate = other.creationDate;
        this.isFavorite = other.isFavorite;
    }

    /**
     * Retourne une instance de Attachment à partir d'une instance de IAttachment.
     * @param other : Instance de IAttachment.
     * @returns : Instance de Attachment.
     */
    public static from(other: IAttachment) {
        if (!!other) {
            const instance = new Attachment();

            instance.id = other.id;
            instance.documentId = other.documentId;
            instance.name = other.name;
            instance.size = other.size;
            instance.creationDate = other.creationDate;
            instance.isFavorite = other.isFavorite;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne un tableau d'instances de Attachment à partir d'un tableau d'instances de IAttachment.
     * @param other : Tableau d'instances de IAttachment.
     * @returns : Tableau d'instances de Attachment.
     */
    public static fromArray(others: IAttachment[]) {
        if (!!others) {
            let attachments: Attachment[] = [];

            others.forEach((x) => {
                const attachment = Attachment.from(x);
                attachments.push(attachment);
            });

            return attachments;
        } else {
            return null;
        }
    }
}
